module.exports = __webpack_public_path__ + "static/media/plaque_leclerc22.6adaea20.png";